<script>
	import ContentPage from '@/components/pages/ContentPage'

	export default {
		name: 'NewsOverviewPage',
		extends: ContentPage
	}
</script>
